import React from 'react';
import { motion } from 'framer-motion';
import { PurchaseButton } from './PurchaseButton';
import { ShieldCheck } from 'lucide-react';
export function CheckoutSection() {
  return <section id="checkout" className="py-24 px-4 bg-primary relative scroll-mt-10 overflow-hidden" data-id="element-65">
      <div className="absolute inset-0 opacity-15 bg-[radial-gradient(circle_at_center,_var(--tw-gradient-stops))] from-soft via-transparent to-transparent" data-id="element-66"></div>
      <div className="absolute top-10 left-10 w-48 h-48 bg-accent/30 rounded-full blur-3xl" data-id="element-67"></div>
      <div className="absolute bottom-10 right-10 w-64 h-64 bg-gold/20 rounded-full blur-3xl" data-id="element-68"></div>

      <div className="max-w-6xl mx-auto relative z-10 grid md:grid-cols-2 gap-10 lg:gap-14 items-center" data-id="element-69">
        <motion.div initial={{
        opacity: 0,
        x: -20
      }} whileInView={{
        opacity: 1,
        x: 0
      }} viewport={{
        once: true
      }} className="relative flex justify-center order-1 md:order-1" data-id="element-70">
          <div className="absolute inset-0 bg-gradient-to-br from-soft/30 to-accent/20 rounded-3xl blur-3xl scale-90" data-id="element-71"></div>
          <img src="https://cdn.magicpatterns.com/uploads/hL9sKxaCgzB83SFtbj1PpB/Ad7.png" alt="Vista completa del paquete EL CÓDIGO DEL CIERRE™ con guía principal, plan de acción y bonos" className="relative w-full max-w-md md:max-w-full h-auto rounded-2xl shadow-2xl" data-id="element-72" />
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="bg-cream rounded-[2rem] shadow-2xl border-4 border-gold/30 p-8 md:p-10 relative text-center order-2 md:order-2" data-id="element-73">
          <div className="absolute -top-5 left-1/2 -translate-x-1/2 bg-gradient-to-r from-urgency to-accent text-white text-xs font-extrabold px-5 py-2 rounded-full shadow-lg whitespace-nowrap tracking-wide" data-id="element-74">
            🔥 ÚLTIMA OPORTUNIDAD
          </div>

          <h2 className="font-serif font-bold text-2xl md:text-3xl text-primary mb-2 mt-4" data-id="element-75">
            ACCEDE HOY A
          </h2>
          <h3 className="font-serif font-bold text-3xl md:text-4xl text-accent mb-2" data-id="element-76">
            EL CÓDIGO DEL CIERRE™
          </h3>
          <p className="font-sans text-ink/70 italic text-sm mb-8" data-id="element-77">
            Tu proceso de 21 días empieza hoy mismo.
          </p>

          <div className="bg-white rounded-2xl p-6 md:p-7 border-2 border-soft/40 mb-8 shadow-inner" data-id="element-78">
            <p className="text-ink/60 font-sans text-base mb-3" data-id="element-79">
              Valor total:{' '}
              <span className="line-through font-bold text-urgency text-lg" data-id="element-80">
                $86 USD
              </span>
            </p>
            <p className="font-sans font-bold text-primary text-xs uppercase tracking-[0.2em] mb-2" data-id="element-81">
              Precio Especial:
            </p>
            <p className="font-serif font-extrabold text-5xl md:text-6xl text-primary leading-none mb-4" data-id="element-82">
              $6.99{' '}
              <span className="text-2xl md:text-3xl text-accent" data-id="element-83">USD</span>
            </p>
            <div className="flex items-center justify-center gap-2 text-relief" data-id="element-84">
              <ShieldCheck size={16} data-id="element-85" />
              <p className="text-xs font-bold font-sans" data-id="element-86">
                Pago único · Sin suscripciones ocultas
              </p>
            </div>
          </div>

          <PurchaseButton text="SÍ, QUIERO ACCESO INMEDIATO" href="https://rutinaspracticas.com/cart/53014801645890:1" data-id="element-87" />
        </motion.div>
      </div>
    </section>;
}